"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveVocabCountForCEFRLevel = exports.getNumberOfWordsToNextLevel = exports.getUserCEFRLevel = void 0;
const types_1 = require("@fluent-forever/types");
const getUserCEFRLevel = (knownWords) => {
    const wordsForEachLevel = types_1.CEFRLevelsAndVocabCount;
    const nextLevelIndex = wordsForEachLevel.findIndex((levelInfo) => knownWords < levelInfo.activeVocabCount);
    if (nextLevelIndex !== -1) {
        return wordsForEachLevel[nextLevelIndex - 1].level;
    }
    return types_1.CEFRLevel.C2;
};
exports.getUserCEFRLevel = getUserCEFRLevel;
const getNumberOfWordsToNextLevel = (knownWords) => {
    const wordsForEachLevel = types_1.CEFRLevelsAndVocabCount;
    const nextLevel = wordsForEachLevel.find((levelInfo) => knownWords < levelInfo.activeVocabCount);
    if (nextLevel) {
        return nextLevel.activeVocabCount - knownWords;
    }
    return 0;
};
exports.getNumberOfWordsToNextLevel = getNumberOfWordsToNextLevel;
const getActiveVocabCountForCEFRLevel = (level) => {
    const matchingLevel = types_1.CEFRLevelsAndVocabCount.find((levelInfo) => levelInfo.level === level);
    return matchingLevel ? matchingLevel.activeVocabCount : 0;
};
exports.getActiveVocabCountForCEFRLevel = getActiveVocabCountForCEFRLevel;
//# sourceMappingURL=languageProgress.js.map